import Analysis from 'models/analysis';
import analysisApi from 'api/analysis';
import AnalysisTabs from 'components/analysisTabs';
import branchApi from 'api/branch';
import customerApi from 'api/customer';
import dealerApi from 'api/dealer';
import EmailModal from 'components/layout/emailModal';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import generateDetailedView, {emailSummary} from './reportDetailedView';
import Header from 'components/layout/header';
import isInternetExplorer from 'helpers/internetExplorer';
import Loader from 'components/loader';
import moment from 'moment';
import PageFooter from 'components/layout/pageFooter';
import path from 'path';
import poolApi from 'api/pool';
import productApi from 'api/product';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import ReportLinkHelper from 'helpers/reportLinkHelper';
import ReportViewer from 'components/reports/reportViewer';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {chemicalBaseTypeNames, emailSendingTypes, countries} from 'helpers/constants';
import {idealRanges as table, getContactName} from 'helpers/dataHelpers';
import IntlWrapper from 'components/layout/intlWrapper';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import NoteFooter from 'components/notes/NoteFooter';


// Register in router
let render = (container, params) => {
  console.info('[UI.page.report] rendering page');
  events.publish('page-change', {page: 'customer'});

  let _id;
  let _contactid;

  if (params.id) {
    _id = parseInt(params.id.split('.')[0]);
    _contactid = parseInt(params.id.split('.').length > 1 ? params.id.split('.')[1] : null);
  }

  ReactDOM.render(<IntlWrapper>
    <WrapperWaterAnalysisReport
      customerID={_id}
      contactId={_contactid}
      poolID={parseInt(params.system)}
      analysisID={parseInt(params.analysisID)}
      last={params.analysisID === 'last'}
      showPrint={!!params.print}/></IntlWrapper>, container);
};

console.info('[UI.page.report] register route');
router.rr.add([{path: 'customer/:id/:system/analysis/report/:analysisID', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{
  path: 'customer/:id/:system/analysis/report/:analysisID/:print',
  handler: routeUtils.requireAuth(render),
}]);
router.rr.add([{
  path: 'customer/:id/:system/analysis/report/history/:analysisID',
  handler: routeUtils.requireAuth(render),
}]);
router.rr.add([{
  path: 'customer/:id/:system/analysis/report/history/:analysisID/:print/',
  handler: routeUtils.requireAuth(render),
}]);

// Collection of helpers to generate links for report page since so many possibilities with detailed/print and post-analysis/history view
class ReportRouting {
  static get printView() {
    if (!location.hash.includes('print')) {
      return path.join(location.hash, 'print');
    }
    return location.hash;
  }

  static get detailedView() {
    if (location.hash.includes('print')) {
      return path.join(location.hash, '..');
    }
    return location.hash;
  }

  static get newAnalysis() {
    return location.hash.split('report')[0];
  }

  static editAnalysis(id) {
    return path.join(ReportRouting.newAnalysis, id.toString());
  }

  static printToggleLink(printState) {
    return printState ? ReportRouting.detailedView : ReportRouting.printView;
  }

  static get isHistoryView() {
    return window.location.href.includes('history');
  }

  static upLevel(num = 0) {
    return path.join(location.hash, ...new Array(num).fill('..'));
  }

  static systemPath(showPrint) {
    if (ReportRouting.isHistoryView && showPrint) {
      return ReportRouting.upLevel(5);
    }
    if (ReportRouting.isHistoryView || showPrint) {
      return ReportRouting.upLevel(4);
    }
    return ReportRouting.upLevel(3);
  }
}

// Page object
class WaterAnalysisReport extends React.Component {
  static propTypes = {
    analysisID: PropTypes.number,
    customerID: PropTypes.number,
    poolID: PropTypes.number,
    showPrint: PropTypes.bool,
    last: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  state = {
    analyses: [new Analysis({}), new Analysis({})],
    customer: {
      customerContacts: [],
    },
    loaded: false,
    pool: {},
    products: [],
    dealer: {},
    reportURL: undefined,
  };


  componentDidMount() {
    if (!ReportRouting.isHistoryView) {
      session.setEdittingTests(this.props.poolID, this.props.analysisID);
    }
    this.fetchData(this.GetReportLink.bind(this));
  }

  componentWillReceiveProps(props) {
    this.props = props;
    this.fetchData(this.GetReportLink.bind(this));
  }

  getReport = () => {
    let {formatMessage} = this.props.intl;
    let tableRows = generateDetailedView(this.props.intl, this.state.dealer,
      this.state.branch, this.state.pool, this.state.products, this.state.analyses, formatMessage, false, true);
    let reportHeaderNames = [<FormattedMessage key='current' id='general.current' />, <FormattedMessage key='previous' id='general.previous'/>];
    let reportHeaders = this.state.analyses.map((analysis, i) =>
      <th key={'tabledateheader' + i}>
        {analysis.created ?
          <span>
            {reportHeaderNames[i]}<br/>
            {moment(analysis.created).format('ll')}
          </span> :
          formatMessage({id: 'test.history.no.analysis'})
        }
      </th>
    );

    return !this.props.showPrint ? <table className='table-biolab analysis-report table-striped table-vertical-rules'>
      <thead>
        <tr>
          <th>{formatMessage({id: 'general.categories'})}<ToolTip position={tooltipPositions.rightBottom}
                                                                  title={formatMessage({id: 'report.category.tooltip'})}
                                                                  iconOnly={true}
                                                                  invert={true}/></th>
          <th>{formatMessage({id: 'general.ideal'})}</th>
          {reportHeaders}
        </tr>
      </thead>
      <tbody>
        {tableRows}
      </tbody>
    </table> :
      null
      ;
  };

  GetReportLink = () => {
    // Get Report JSON
    ReportLinkHelper.getReportLink(this.state.analyses[0].id, this.props.intl.locale).then(function(xhr, response) {
      let linkurl = '/ReportViewer?' + response.split('?')[1];

      if (response.indexOf('/pdf') !== -1) {
        linkurl = '/pdf?' + response.split('?')[1];
      }

      this.setState({
        reportURL: response,
        reportURLInternal: linkurl,
        loaded: true,
      });
    }.bind(this));
  };

  editAnalysis = () => {
    let id = this.state.analyses[0].id;

    if (id) {
      return ReportRouting.editAnalysis(id);
    }
    return path.join(window.location.hash, '..');
  };

  emailModal = () => {
    let message = this.props.showPrint ? '' : ReactDOMServer.renderToStaticMarkup(<IntlWrapper>{this.getReport()}</IntlWrapper>);

    message = message.replace(/<td>/g, '<td style="padding: 5px 15px;">');
    if (this.state.analyses[0].imported) {
      return null;
    }

    return <EmailModal
      title={<FormattedMessage id='reports.water.analysis' />}
      customerID={this.state.customer.id}
      contacts={this.state.customer.customerContacts}
      type={emailSendingTypes.analysis}
      analysisID={this.state.analyses[0].id}
      analysisBody={emailSummary(this.props.intl, this.state.analyses[0], this.state.pool, this.state.products, this.state.dealer, null, true)}
      dealerName={this.state.dealer.name}
      caslRestricted={this.state.dealer.country === countries.CA}
      reportURL={this.state.reportURL}/>;
  };

  fetchData = callback => {
    let apis = [];

    apis.push(analysisApi.getRecent(this.props.poolID, this.props.last ? null : this.props.analysisID));
    apis.push(customerApi.getCustomer(parseInt(this.props.customerID)));
    apis.push(poolApi.getPool(parseInt(this.props.poolID)));
    apis.push(productApi.getProducts());
    apis.push(dealerApi.getDealer(parseInt(session.getUser().dealerId)));
    Promise.all(apis)
      .then(([analyses, customer, pool, products, dealer]) => {
        for (let i = 0; i < analyses.length; ++i) {
          this.state.analyses[i] = analyses[i];
        }

        const isImported = analyses && analyses[0] && analyses[0].imported;

        // Dealer preference to set default page to print page
        if (!this.state.loaded && parseInt(dealer.defaultPreview) === 0 && !isImported) {
          this.showReport(true);
        }

        branchApi.getBranch(customer.branchID)
          .then(branch => {
            this.setState({
              analyses: this.state.analyses,
              branch: branch,
              customer: customer,
              pool: pool,
              products: products,
              dealer: dealer,
            });
          });

        callback();
      })
      .catch((e) => {
        console.error(e);
        events.publish('error.user', {message: <FormattedMessage id='test.history.error.fetching' />});
      });
  };

  print = () => {
    let win = window.open(this.state.reportURLInternal);

    setTimeout(() => {
      win.print();
    }, 5000);
  };

  printTable = () => {
    events.publish('print',
      <IntlWrapper>
        <h3><FormattedMessage id="preferences.analysis.product.recommendations"/></h3>
        <br/>
        {this.getReport()}
      </IntlWrapper>
    );
  };

  showReport = (replace = false) => {
    if (this.props.showPrint) {
      return;
    }

    let newHash = ReportRouting.printView;

    if (replace) {
      window.location.replace(newHash);
    } else {
      window.location.hash = newHash;
    }
  };

  render() {
    //Generate page title (customer name)
    let contact = null;
    let contactName = 'Customer';
    let {formatMessage} = this.props.intl;
    const isImported = this.state.analyses && this.state.analyses[0] && !!this.state.analyses[0].imported;

    if (this.state.customer.customerContacts.length > 0) {
      contact = this.state.customer.customerContacts[0];

      for (let i = 0; i < this.state.customer.customerContacts.length; i++) {
        if (this.state.customer.customerContacts[i].id === this.props.contactId) {
          contact = this.state.customer.customerContacts[i];
        }
      }

      contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;
    }

    //Generate page subtitle
    let subTitle = this.state.pool.softSoakTRIO ? 'Trio ' : '';

    subTitle += chemicalBaseTypeNames(this.state.pool.typeID, this.state.pool.chemicalBaseTypeID || 2, formatMessage);

    //Generate customer id for url purpose
    let customerUrl = this.props.customerID.toString();

    if (!isNaN(this.props.contactId)) {
      customerUrl += '.' + this.props.contactId;
    }

    let alexProdID = this.state.customer && this.state.customer.accountNum ? <div className='heading-alexid'>
      <span className='heading-alexid-title'><FormattedMessage id='general.alexid'/>:</span> {this.state.customer.accountNum}
    </div> : null;


    return <div className='container analysis-report-page'>
      <Loader loaded={this.state.loaded}>
        <Header mainTitle={contactName}
                mainTitleReturn={'customer/' + customerUrl}
                subTitle={subTitle}>
          {alexProdID}
        </Header>

        <AnalysisTabs systemPath={ReportRouting.systemPath(this.props.showPrint)}/>

        <div className='row'
             style={{marginBottom: 30}}>
          <div className='col-xs-9'>
            <h2 style={{display: 'inline'}}
                className='blue'>
              {this.props.showPrint && !isImported ?
                formatMessage({id: 'preferences.analysis.product.recommendations'}) :
                formatMessage({id: 'preferences.analysis.analysis.results'})}
              {!isImported ? <span className='divider'>{'  |  '}</span> : null}
            </h2>
            <a style={{textDecoration: 'underline'}}
               href={ReportRouting.printToggleLink(this.props.showPrint)}>
              {this.props.showPrint && !isImported ?
                formatMessage({id: 'preferences.analysis.analysis.results'}) :
                isImported ? null :
                  formatMessage({id: 'preferences.analysis.product.recommendations'})}
            </a>
          </div>
          <div className='col-xs-3'>
            <div className='pull-right'>
              {ReportRouting.isHistoryView ?
                <a href={ReportRouting.newAnalysis}
                   style={{textDecoration: 'underline'}}><FormattedMessage id="report.new.water.test"/></a> :
                <a href={this.editAnalysis()}
                   style={{textDecoration: 'underline'}}><i className='bl bl-edit'/>
                  <span style={{marginLeft: 5}}><FormattedMessage id="report.edit.water.test"/></span>
                </a>
              }
            </div>
          </div>
        </div>

        {this.getReport()}
        {this.props.showPrint && !isImported && <ReportViewer url={this.state.reportURLInternal}/>}

        {!isImported && (!isInternetExplorer() || !this.props.showPrint) &&
          <PageFooter>
            <NoteFooter customer={this.state.customer} pool={this.state.pool} analysis={this.state.analyses[0]} />
            {this.emailModal()}
            {this.props.showPrint && <FooterButton label={formatMessage({id: 'general.print'})}
                                                   icon='bl bl-2x bl-print'
                                                   onClick={this.print}/>}
            {!this.props.showPrint && <FooterButton label={formatMessage({id: 'general.print'})}
                                                    icon='bl bl-2x bl-print'
                                                    onClick={this.printTable}/>}
          </PageFooter>
        }
      </Loader>
    </div>;
  }
}

const WrapperWaterAnalysisReport = injectIntl(WaterAnalysisReport);

export default WrapperWaterAnalysisReport;
